import { t } from 'i18next'
import { z } from 'zod'
import { checkMod11 } from '../../../utils'

export const GenericSupplierColumns = translator => [
  {
    field: 'name',
    fieldSet: 'name',
    headerName: translator('name', { ns: 'common' }),
    flex: 1,
    cellClassName: 'font-weight-semi-bold',
  },
  {
    field: 'notes',
    fieldSet: 'notes',
    headerName: translator('description', { ns: 'common' }),
    flex: 1,
  },
  { field: 'organizationNumber', fieldSet: 'organizationNumber', headerName: translator('organizationNumber', { ns: 'supplier' }), flex: 1 },
]

export const GenericSupplierFormFields = {
  name: z.string().nonempty(t('nameIsRequired', { ns: 'supplier' })),
  organizationNumber: z
    .string()
    .refine(
      value => {
        if (value.length === 0) return true
        return checkMod11(value)
      },
      {
        message: t('wrongOrganizationNumber', { ns: 'supplier' }),
      },
    )
    .optional(),
  notes: z.string().or(z.null()).optional(),
}
